import React from "react";
import { Link } from "react-router-dom";
import "./LeadTime.css";
import "../../styleguide.css";

function LeadTime(props) {
  const {
    x1200PxLogo_Icam__20081,
    headerMenuDefault61Props,
    headerMenuDefault51Props,
    headerMenuDefault52Props,
    headerMenuDefaultProps,
    headerMenuDefault53Props,
    headerMenuDefault54Props,
    headerMenuDefault62Props,
  } = props;

  const [selectedOptions, setSelectedOptions] = React.useState({});
  const [l_yesCount, setL_yesCount] = React.useState(0);

  function clicked(question, option) {
    // Si l'option cliquée est la même que celle déjà sélectionnée, on la désélectionne
    if (selectedOptions[question] === option) {
      setSelectedOptions((prevSelectedOptions) => {
        const newOptions = { ...prevSelectedOptions };
        delete newOptions[question];
        return newOptions;
      });
      // Si on désélectionne un "Yes", on décrémente le score
      if (option === "Yes") {
        setL_yesCount((prevCount) => prevCount - 1);
      }
      return;
    }

    // Sinon, on met à jour la sélection
    const previousOption = selectedOptions[question];
    setSelectedOptions((prevSelectedOptions) => ({
      ...prevSelectedOptions,
      [question]: option,
    }));
    
    // Si on passe de "No" à "Yes", on incrémente le score
    if (option === "Yes" && previousOption !== "Yes") {
      setL_yesCount((prevCount) => prevCount + 1);
    }
    // Si on passe de "Yes" à "No", on décrémente le score
    else if (option === "No" && previousOption === "Yes") {
      setL_yesCount((prevCount) => prevCount - 1);
    }
  }

  return (
    <div className="environmental-container">
      <div className="environmental-content">
        <h1 className="environmental-title">
          LEAD TIME ASSESSMENT
        </h1>
        
        <div className="lead-time-description">
          <p>This section will assess your company's lead time management practices. Please proceed to answer questions in the following subsections:</p>
          
          <div className="lead-time-sections">
            <Link to="/lead-time-1" className="section-button">
              <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                <path d="M2 17l10 5 10-5"/>
                <path d="M2 12l10 5 10-5"/>
              </svg>
              Lead Time Part 1
            </Link>
            <Link to="/lead-time-2" className="section-button">
              <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                <path d="M2 17l10 5 10-5"/>
                <path d="M2 12l10 5 10-5"/>
              </svg>
              Lead Time Part 2
            </Link>
          </div>
        </div>
        
        <nav className="secondary-nav" aria-label="Secondary Navigation">
          <ul className="nav-menu" role="menubar">
            <li className="nav-item" role="none">
              <Link to="/acquisition" className="nav-link" role="menuitem">
                <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18"/>
                  <path d="M18.4 9l-6-6-3 6-3 3 3 9h9"/>
                </svg>
                Acquisition
              </Link>
            </li>
            <li className="nav-item" role="none">
              <Link to="/acquisition" className="nav-link" role="menuitem">
                <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                {headerMenuDefault53Props?.children || "Environmental"}
              </Link>
            </li>
            <li className="nav-item" role="none">
              <Link to="/acquisition" className="nav-link" role="menuitem">
                <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
                {headerMenuDefault54Props?.children || "Social"}
              </Link>
            </li>
            <li className="nav-item active" role="none">
              <Link to="/acquisition" className="nav-link" role="menuitem" aria-current="page">
                <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                {headerMenuDefault62Props?.children || "Lead Time"}
              </Link>
            </li>
          </ul>
        </nav>
        
        <div className="form-actions">
          <Link to="/home" className="btn-secondary">
            <svg className="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5"/>
              <path d="M12 19l-7-7 7-7"/>
            </svg>
            Back
          </Link>
          <Link to="/lead-time-1" className="btn-primary">
            Start Lead Time Assessment
            <svg className="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14"/>
              <path d="m12 5 7 7-7 7"/>
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LeadTime;
